enum EContentTypes {
  json = "application/json",
  multipart = "multipart/form-data",
  auto = "auto",
}

export default EContentTypes;
